import React, { type FunctionComponent, type PropsWithChildren } from 'react'
import { ThemeProvider, type IPP_SUPPORTED_LOCALE } from '@retailer-platform/shared-components'
import { type TDS_LOCALES } from '@retailer-platform/shared-components/src/tds'
import { TourProvider } from '@reactour/tour'
import { NavProvider } from '../../nav/utils/NavProvider'
import { UserFeedbackProvider } from '../../user-feedback/UserFeedbackProvider'
import { AdminControlsProvider } from '../../../../utils/contexts/admin-controls/AdminControlsContext'
import { BetaEnvBanner } from '../../beta-env-banner/BetaEnvBanner'
import { App as LegacyAppProvider } from '../../../../legacy/dash-components/app/App'
import { AppRouter } from '../../../../routes/AppRouter'
import { getDefaultTourProviderProps } from '../../../../utils/tour/tour.utils'
import { useCurrentAccountContext } from '../../../../utils/current-account/CurrentAccountContext'
import { FeatureToggle } from '../../../../legacy/contexts/featureToggles/FeatureToggleContext'
import { AppProviderStyling } from './AppProviderStyling'

interface Props {
  locale: IPP_SUPPORTED_LOCALE
}

const tourProviderProps = getDefaultTourProviderProps()

export const AppUIProviders: FunctionComponent<PropsWithChildren<Props>> = ({ locale }) => {
  const { account } = useCurrentAccountContext()
  const hasNavV3 = !!account?.featureToggles?.find(f => f.name === FeatureToggle.IppNavV3)

  return (
    <ThemeProvider locale={locale as unknown as TDS_LOCALES} enableIdsRouting={hasNavV3}>
      <NavProvider>
        <UserFeedbackProvider>
          <AdminControlsProvider>
            <TourProvider {...tourProviderProps}>
              <BetaEnvBanner />
              <AppProviderStyling>
                <LegacyAppProvider>
                  <AppRouter />
                </LegacyAppProvider>
              </AppProviderStyling>
            </TourProvider>
          </AdminControlsProvider>
        </UserFeedbackProvider>
      </NavProvider>
    </ThemeProvider>
  )
}

export default AppUIProviders
